




































import { Component, Vue } from 'vue-property-decorator'
import { useDoctorService } from '~/domains/doctor/DoctorService'
import type { DoctorSpecialityCheckResult as SpecResponse } from '~/domains/doctor/Doctor.types'
import { ToastTypesEnum } from '~/types/app/store/ToastTypesEnum'

import Redactorx from '~/components/frequentPatterns/editor/Redactorx.vue'
import Btn from '~/components/UI/Btn.vue'
import MainContentWithAd from '~/components/layouts/types/default/MainContentWithAd.vue'

@Component({
  components: {
    MainContentWithAd,
    Btn,
    Redactorx
  },
  meta: {
    ad: {
      topAndBottom: false
    }
  },
  head () {
    return {
      title: 'Классификатор профессионального контента на основе машинного обучения'
    }
  }
})
export default class SpecPage extends Vue {
  post = ''

  loading = false

  result: SpecResponse | null = null

  get isPositiveScore () {
    return this.result?.score && this.result.score > 0.8
  }

  get resultSpecName () {
    if (!this.result) {
      return ''
    }

    return this.isPositiveScore ? this.result.nameSpec : 'нет медицинской специализации'
  }

  get redactorXConfig () {
    return {
      placeholder: 'Вставьте медицинский текст для опредления специализации',
      editor: {
        minHeight: '220px'
      }
    }
  }

  async checkSpeciality () {
    if (!this.post) {
      return
    }

    this.loading = true

    try {
      this.result = await useDoctorService().checkSpecialityByText(this.post)
    } catch (e) {
      this.$storeModules.toasts.addToast({
        content: e.message,
        type: ToastTypesEnum.error
      })
    } finally {
      this.loading = false
    }
  }
}
